import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getAccessLoginReport } from '../../app/store/actions/users';
import HeaderComponent from '../../components/table/header/headerComponent';
import FeedbackMessage from './components/FeedbackMessage';
import Form from './components/Form';
import GenerateReportButton from './components/GenerateReportButton';

class AccessLoginReportPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialDate: moment().format('DD/MM/YYYY'),
      finalDate: moment().format('DD/MM/YYYY'),
      cnpj: '',
      corporateName: '',
      clientERPCode: '',
      errorMessage: '',
      successMessage: '',
    };
  }

  handleDate = (date, type) => this.setState({ [type]: date });

  handleText = async (input, field) => {
    if (field === 'cnpj') {
      const regexOnlyNumbers = /\D/;
      if (!regexOnlyNumbers.test(input) && !isNaN(input)) await this.setState({ [`${field}`]: input });
    } else {
      await this.setState({ [`${field}`]: input });
    }
  }

  getAccessLoginReport = async () => {
    const {
      initialDate, finalDate, cnpj, corporateName, clientERPCode,
    } = this.state;

    try {
      const response = await this.props.getAccessLoginReport({
        initialDate, finalDate, cnpj, corporateName, clientERPCode
      });

      if (response) {
        const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
        const link = document.createElement('a');
        link.href = url;
        const filePath = 'logger-login.csv';
        link.setAttribute('download', filePath);
        document.body.appendChild(link);
        link.click();

        await this.setState({ 
          errorMessage: '', 
          successMessage: I18n.t('reportGeneratedSuccessfully')
        });
      } else {
        await this.setState({
          errorMessage: I18n.t('dataNotFound'),
          successMessage: '',
        });
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        if (error.response.data.error.code === 1608) {
          await this.setState({
            errorMessage: I18n.t('initialDateNotFound'),
            successMessage: '',
          });
        } else if (error.response.data.error.code === 1609) {
          await this.setState({
            errorMessage: I18n.t('finalDateNotFound'),
            successMessage: '',
          });
        } else if (error.response.data.error.code === 1610) {
          await this.setState({
            errorMessage: I18n.t('invalidInitialDate'),
            successMessage: '',
          });
        } else if (error.response.data.error.code === 1611) {
          await this.setState({
            errorMessage: I18n.t('invalidFinalDate'),
            successMessage: '',
          });
        } else if (error.response.data.error.code === 1612) {
          await this.setState({
            errorMessage: I18n.t('dateGreaterThanToday'),
            successMessage: '',
          });
        } else if (error.response.data.error.code === 1613) {
          await this.setState({
            errorMessage: I18n.t('initialDateGreaterThanFinalDate'),
            successMessage: '',
          });
        } else {
          await this.setState({
            errorMessage: I18n.t('unmappedError'),
            successMessage: '',
          });
        }
      } else {
        await this.setState({
          errorMessage: I18n.t('unknownError'),
          successMessage: '',
        });
      }
    }
  }

  render() {
    const { companyTag } = this.props;

    const {
      initialDate, finalDate, cnpj, corporateName, clientERPCode, successMessage, errorMessage,
    } = this.state;

    return (
      <div className="main-table">
        <div className="main-header-table">
          <HeaderComponent title={I18n.t('accessLogin')} />
          <Form
            initialDate={initialDate}
            finalDate={finalDate}
            handleDate={this.handleDate}
            cnpj={cnpj}
            corporateName={corporateName}
            clientERPCode={clientERPCode}
            handleText={this.handleText}
            companyTag={companyTag}
          />
          <GenerateReportButton
            text='generateReport'
            ariaLabel='Gerar Relatório'
            handleConfirmation={this.getAccessLoginReport}
          />
        </div>
        <FeedbackMessage
          successMessage={successMessage}
          successColorMessage='green'
          errorMessage={errorMessage}
          errorColorMessage='red'
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  companyTag: state.settings.companyTag,
});

const mapDispatchToProps = dispatch => ({
  getAccessLoginReport: (data) => dispatch(getAccessLoginReport(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessLoginReportPage);
